import styled, { css } from 'styled-components';
import { media } from '@common/theme';

interface BackgroundWrapperProps {
  isFullDim: boolean;
  customHeight?: string;
}

export const BackgroundWrapper = styled.div<BackgroundWrapperProps>`
  position: relative;
  width: 100%;
  min-height: ${({ customHeight }) => customHeight || '80vw'};
  ${media.desktop<BackgroundWrapperProps>`
    min-height: ${({ customHeight }) => customHeight || 'initial'};
  `}

  ${({ isFullDim }) =>
    isFullDim &&
    css`
      width: 100%;
      height: 100%;
    `}
`;

export const Background = styled.div<{ hasTopBorderRadius?: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 1;
  background-size: cover;
  background-position: center center;

  ${({ hasTopBorderRadius }) =>
    hasTopBorderRadius &&
    `
    border-radius: 12px 12px 0 0;
  `}
`;

export const Content = styled.div<{ withBlurredMobileBackground: boolean }>`
  position: relative;
  z-index: 2;
  backdrop-filter: ${({ withBlurredMobileBackground }) =>
    withBlurredMobileBackground ? 'blur(5px)' : 'none'};
`;

export const EntityImagePreview = styled.div<{ background: boolean }>`
  ${({ background, theme }) =>
    !background &&
    css`
      background-color: ${theme.customColors.tertiary};
    `};
  height: 150px;

  ${media.desktop`
    height: 254px;
  `}
`;
